import axios from '@axios'

export default {
  namespaced: true,
  state: {
    items: [],
  },
  getters: {
    getItems(state) {
      return state.items
    },
    getSelectedItems(state) {
      return state.items.map(service_orders_status => ({
        value: service_orders_status.id,
        label: service_orders_status.status,
      }))
    },
  },
  mutations: {
    setData(state, value) {
      state.items = value
    },
  },
  actions: {
    async getAll({commit}, params) {
      const {data} = await axios.get('v1/service_orders_status', {params})
      if (!data) {
        return []
      }
      commit('setData', data.data)
      return data
    },
  },
}
